import { Contacts } from './Contacts';

export default Contacts;



// WEBPACK FOOTER //
// ./src/components/Contacts/index.js